import React, { Component } from "react";
import { withRouter } from "../common/with-router";
import { Row, Col, Breadcrumb, Card, Container } from "react-bootstrap";

class HowItWorks extends Component {
    render() {
        return (
            <div className="mt-4">
                <Breadcrumb className="p-2 rounded">
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>Como Funciona</Breadcrumb.Item>
                </Breadcrumb>

                <Container>
                    <div className="text-center my-5">
                        <h2 className="font-weight-bold">Replay esportivo profissional com um toque de botão</h2>
                        <p className="lead text-muted">Uma plataforma proprietária que integra hardware, software e nuvem para o esporte.</p>
                    </div>

                    {/* O Passo a Passo Operacional */}
                    <div className="mb-5">
                        <h4 className="font-weight-bold mb-4 text-center">O Processo</h4>
                        <Row>
                            {[
                                { step: "1", title: "O Lance", desc: "O lance acontece naturalmente na quadra.", icon: "bi-activity" },
                                { step: "2", title: "Acionamento", desc: "O operador aciona o botão físico dedicado.", icon: "bi-hand-index-fill" },
                                { step: "3", title: "Nuvem", desc: "Processamento automático e envio para a nuvem.", icon: "bi-cloud-arrow-up-fill" },
                                { step: "4", title: "Acesso", desc: "Atletas acessam via QR Code em poucos minutos.", icon: "bi-qr-code-scan" }
                            ].map((item, index) => (
                                <Col key={index} md={3} className="mb-4">
                                    <div className="d-flex flex-column align-items-center text-center">
                                        <div className="bg-danger text-white rounded-circle mb-3 d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px', fontWeight: 'bold' }}>
                                            {item.step}
                                        </div>
                                        <h6 className="font-weight-bold">{item.title}</h6>
                                        <p className="small text-muted">{item.desc}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <div className="text-center mb-5">
                        <p className="text-muted">Todo o processo foi projetado para ser <strong>simples, rápido e confiável</strong>, sem interferir no andamento do jogo.</p>
                    </div>

                    {/* Tecnologia Desenvolvida */}
                    <Row className="mb-5">
                        <Col md={4} className="mb-3">
                            <Card className="h-100 border-danger border-top border-4 shadow-sm">
                                <Card.Body>
                                    <h5 className="font-weight-bold"><i className="bi bi-cpu text-danger"></i> Hardware</h5>
                                    <p className="small text-muted">Dispositivo dedicado com processamento local, botão físico para marcação e captura em alta definição.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-3">
                            <Card className="h-100 border-danger border-top border-4 shadow-sm">
                                <Card.Body>
                                    <h5 className="font-weight-bold"><i className="bi bi-code-slash text-danger"></i> Software</h5>
                                    <p className="small text-muted">Aplicação embarcada para processamento e plataforma web com interface simples e intuitiva.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="mb-3">
                            <Card className="h-100 border-danger border-top border-4 shadow-sm">
                                <Card.Body>
                                    <h5 className="font-weight-bold"><i className="bi bi-server text-danger"></i> Infraestrutura</h5>
                                    <p className="small text-muted">Cloud computing em ambiente AWS com armazenamento seguro, escalável e otimizado para velocidade.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* PARA QUEM É - Transformado em Cards de Relevância */}
                    <div className="mb-5">
                        <h4 className="font-weight-bold mb-4 text-center">Para quem é a Replay Pro?</h4>
                        <Row className="justify-content-center">
                            {[
                                { title: "Quadras Esportivas", icon: "bi-grid-3x3", desc: "Modernização do espaço e atração de novos atletas." },
                                { title: "Arenas e Clubes", icon: "bi-building", desc: "Valorização da infraestrutura e experiência premium." },
                                { title: "Campeonatos", icon: "bi-trophy", desc: "Engajamento para torneios amadores e profissionais." },
                                { title: "Organizadores", icon: "bi-calendar-event", desc: "Geração de conteúdo viral para eventos esportivos." },
                                { title: "Patrocinadores", icon: "bi-megaphone", desc: "Novas oportunidades de mídia digital com impacto real." }
                            ].map((item, index) => (
                                <Col key={index} xs={12} sm={6} md={4} lg={2} className="mb-3 d-flex flex-fill">
                                    <Card className="w-100 border-0 shadow-sm text-center pt-3 pb-2 hover-shadow transition">
                                        <Card.Body className="d-flex flex-column align-items-center">
                                            <i className={`bi ${item.icon} text-danger mb-2`} style={{ fontSize: '1.8rem' }}></i>
                                            <h6 className="font-weight-bold small mb-1">{item.title}</h6>
                                            <p className="text-muted" style={{ fontSize: '0.75rem' }}>{item.desc}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <hr className="my-5" />

                    {/* Entregáveis ao Atleta */}
                    <div className="mb-5">
                        <h4 className="font-weight-bold mb-4 text-center">O que entregamos nas mãos do atleta:</h4>
                        <Row className="justify-content-center">
                            {[
                                {
                                    title: "Alta Qualidade",
                                    detail: "Full HD (60fps)",
                                    desc: "Captura de vídeo em alta definição para máxima fluidez.",
                                    icon: "bi-patch-check-fill"
                                },
                                {
                                    title: "Acesso Prático",
                                    detail: "Sem necessidade de App",
                                    desc: "Acesso imediato via navegador, sem ocupar memória do celular.",
                                    icon: "bi-qr-code"
                                },
                                {
                                    title: "Engajamento",
                                    detail: "Compartilhamento Social",
                                    desc: "Vídeos prontos para as redes sociais com um clique.",
                                    icon: "bi-share-fill"
                                }
                            ].map((item, index) => (
                                <Col key={index} md={4} className="mb-4">
                                    <Card className="h-100 border-0 shadow-sm text-center py-4" style={{ borderRadius: '15px' }}>
                                        <Card.Body>
                                            <div className="mb-3">
                                                <i className={`bi ${item.icon} text-danger`} style={{ fontSize: '2.5rem' }}></i>
                                            </div>
                                            <h6 className="font-weight-bold text-uppercase small text-muted mb-1">{item.title}</h6>
                                            <h5 className="font-weight-bold text-dark mb-2">{item.detail}</h5>
                                            <p className="text-muted small mb-0">{item.desc}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Container>
            </div>
        );
    }
}

export default withRouter(HowItWorks);